import { orderBy } from 'lodash';

import PropTypes from 'prop-types';
import React from 'react';

import { Tooltip } from 'opencare-crown';

import { FlexRow } from '../../../../common/styles/oc-styled-components';

import {
  ClinicSubRatingBadgeFlexRow,
  ClinicSubRatingBadgeIcon,
} from './styled-components';

export const ClinicSubRatingBadge = ({
  staffRating,
  careQualityRating,
  atmosphereAndEquipmentRating,
  prefix,
  isMobile,
  isMinimal,
  height,
}) => {
  const MIN_VALUE_TO_DISPLAY = 4.5;

  // Sub-rating options descriptor.
  const subRatingOptions = [
    {
      value: staffRating,
      name: 'Top-rated Service',
      description:
        'The caring professionals at this practice are consistently praised by patients for their exceptional care.',
      icon: <ClinicSubRatingBadgeIcon type="team" />,
    },
    {
      value: careQualityRating,
      name: 'Excellence in Patient Care',
      description:
        'The commitment to quality service at this practice shines through in reviews from other patients.',
      icon: <ClinicSubRatingBadgeIcon type="heart" />,
    },
    {
      value: atmosphereAndEquipmentRating,
      name: 'Exceptional Ambiance',
      description:
        'Patients enjoy a pleasant atmosphere during their visit, as recognized by others.',
      icon: <ClinicSubRatingBadgeIcon type="sketch" />,
    },
  ];

  // Select only one sub-rating to display by the highest value.
  const subRatingOptionToDisplay = orderBy(
    subRatingOptions.filter(
      (option) =>
        typeof option.value === 'number'
        && option.value >= MIN_VALUE_TO_DISPLAY,
    ),
    ['value'],
    ['desc'],
  )[0];

  const handleClick = (event) => {
    if (isMobile) {
      // Prevent the default actions on the mobile devices to show the tooltip.
      event.preventDefault();
    }
  };

  if (!subRatingOptionToDisplay) {
    return null;
  }

  return (
    <>
      {prefix}
      <Tooltip title={subRatingOptionToDisplay.description}>
        <ClinicSubRatingBadgeFlexRow
          onClick={handleClick}
          height={height}
          isMinimal={isMinimal}
        >
          <FlexRow>{subRatingOptionToDisplay.icon}</FlexRow>
          <FlexRow style={{ textWrap: 'nowrap' }}>
            {subRatingOptionToDisplay.name}
          </FlexRow>
        </ClinicSubRatingBadgeFlexRow>
      </Tooltip>
    </>
  );
};

ClinicSubRatingBadge.propTypes = {
  staffRating: PropTypes.number,
  careQualityRating: PropTypes.number,
  atmosphereAndEquipmentRating: PropTypes.number,
  isMobile: PropTypes.bool,
  isMinimal: PropTypes.bool,
  height: PropTypes.number,
  prefix: PropTypes.node,
};
